import { TimePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';

export const OpeningHoursPicker = ({
    label,
    value,
    setValue,
}: {
    label: string;
    value: DateTime;
    setValue: (newValue: DateTime) => void;
}) => {
    return (
        <TimePicker
            label={label}
            sx={{
                '&>.MuiInputBase-root': {
                    height: 48,
                },
            }}
            views={['hours', 'minutes']}
            ampm={false}
            value={value}
            minutesStep={10}
            timeSteps={{ minutes: 10 }}
            onChange={(newValue) => {
                if (newValue !== null) {
                    setValue(newValue);
                }
            }}
        />
    );
};
